import {MAX_INPUT_NUMBER_VALUE, MIN_INPUT_NUMBER_VALUE} from "./SurveyUtils";

export function validateSurvey(survey) {
    if (!survey.title) {
        return false;
    }

    for (let questionIdx = 0; questionIdx < survey.questions.length; questionIdx ++) {
        let question = survey.questions[questionIdx];
        if (!validateQuestion(question)) {
            return false;
        }
    }
    return true;
}

export function validateQuestion(question) {
    /* Common validations (not type-specific) */
    if (!question.question) {
        return false;
    }

    if(question.question.length > 5000) {
        return false;
    }

    if (question.options) {
        if (question.options.exceptLast === "true" && question.options.randomize === "false") {
            return false;
        }
        if (question.options.randomize === "true" && question.options.reverse === "true") {
            return false;
        }
    }

    /* Type-specific validations */
    switch(question.type) {
        case "singleChoice":
            return validateSingleChoiceQuestion(question);
        case "multipleChoice":
            return validateMultipleChoiceQuestion(question);
        case "text":
            return validateTextQuestion(question);
        case "selects":
            return validateMatrixQuestion(question);
        case "jumbotron":
            return validateJumbotronQuestion(question);
        case "multipleOpen":
            return validateMultipleOpenQuestion(question);
        case "number":
            return validateNumberQuestion(question);
        case "rating":
            return validateRatingQuestion(question);
        default:
            return true;
    }
}

export function validateChoices(choices) {
    /* Workaround for validating choices and including their own messages */
    /* The indexes of each label are kept */
    let labelsIndexesMap = choices.reduce((acc, choice, index) => {
        acc[choice.label] = acc[choice.label] || [];
        acc[choice.label].push(index);
        return acc;
    }, {});

    /* The validation result is a map of messages - only indexes with issues are included */
    let validationResultMap = {};
    for (let label of Object.keys(labelsIndexesMap)) {
        if (label === "") {
            /* Two or more empty choices */
            if (labelsIndexesMap[label].length > choices.length - 2) {
                for (let index of labelsIndexesMap[label])
                    validationResultMap[index] = "You are required to have at least 2 choices.";
                return validationResultMap;
            }
        }
        else {
            /* For filled choices with duplicates, include all indexes */
            if (labelsIndexesMap[label].length > 1) {
                for (let index of labelsIndexesMap[label])
                    validationResultMap[index] = "Please remove duplicated labels.";
            }
        }
    }
    return validationResultMap;
}

function validateSingleChoiceQuestion(question) {
    let choicesValidationResult = validateChoices(question.choices);
    return Object.keys(choicesValidationResult).length === 0;
}

function validateMultipleChoiceQuestion(question) {
    let choicesValidationResult = validateChoices(question.choices);
    return Object.keys(choicesValidationResult).length === 0;
}

function validateTextQuestion(question) {
    return true;
}

function validateMatrixQuestion(question) {
    let choicesValidationResult = validateChoices(question.selects);
    let optionsValidationResult = validateChoices(question.selects[0].options);
    return (
        Object.keys(choicesValidationResult).length === 0 &&
        Object.keys(optionsValidationResult).length === 0 &&
        question.selects[0].options.length <= 12
    );
}

function validateJumbotronQuestion(question) {
    return true;
}

function validateMultipleOpenQuestion(question) {
    let choicesValidationResult = validateChoices(question.selects);
    return Object.keys(choicesValidationResult).length === 0;
}

function validateNumberQuestion(question) {
    if (typeof question.options["minValue"] !== "undefined" &&
        (question.options["minValue"] < MIN_INPUT_NUMBER_VALUE || question.options["minValue"] >= MAX_INPUT_NUMBER_VALUE)) {
        return false;
    }
    if (typeof question.options["maxValue"] !== "undefined" &&
        (question.options["maxValue"] <= MIN_INPUT_NUMBER_VALUE || question.options["maxValue"] > MAX_INPUT_NUMBER_VALUE)) {
        return false;
    }
    if (typeof question.options["minValue"] !== "undefined" && typeof question.options["maxValue"] !== "undefined") {
        return question.options["minValue"] < question.options["maxValue"];
    }
    return true;
}

function validateRatingQuestion(question) {
    // TODO: implement for rating question story
    return true;
}
